// Porta de reference/expo-frontend/lib/balances.ts para o web.
// Modelo de saldos separados:
// - Disponível (availableBalance): sacável, NÃO apostável.
// - Créditos (creditBalance): apostável, nunca sacável.
// - Em Palpites: soma dos palpites do usuário em torneios ainda não
//   liquidados (resultado desconhecido) — já debitado dos saldos acima na
//   aposta, mas segue sendo dinheiro do usuário até a liquidação, por isso
//   entra no Saldo Total.
// - Total = Disponível + Créditos + Em Palpites.
// Adaptação web: GET /api/me/bets já retorna só as apostas do próprio
// usuário, então não há filtro por userId.
import type { Tournament, User } from "@/types";

export type BetStakeLike = {
  tournamentId: string;
  amount: number;
};

export type UserBalances = {
  available: number;
  credit: number;
  inPlay: number;
  total: number;
};

// Soma das apostas em torneios ainda não liquidados ("upcoming"/"active").
// Apostas de torneios "settled" já viraram prêmio ou perda e não contam.
export function pendingStake(
  bets: BetStakeLike[],
  tournaments: Tournament[],
): number {
  const openIds = new Set(
    tournaments
      .filter((t) => t.status === "upcoming" || t.status === "active")
      .map((t) => t.id),
  );
  let sum = 0;
  for (const b of bets) {
    if (openIds.has(b.tournamentId)) sum += b.amount;
  }
  return sum;
}

export function userBalances(
  user: Pick<User, "balance" | "availableBalance" | "creditBalance">,
  bets: BetStakeLike[],
  tournaments: Tournament[],
): UserBalances {
  // `balance` legado = total (disponível + créditos) — fallback para
  // payloads antigos sem o split.
  const available = user.availableBalance ?? user.balance;
  const credit = user.creditBalance ?? 0;
  const inPlay = pendingStake(bets, tournaments);
  return { available, credit, inPlay, total: available + credit + inPlay };
}
